//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtInput from "../form/MtInput";
import Button from "../other/Button";
export default {
  name: "GiftPatron",
  components: {
    MtInput,
    Button
  },
  props: {
    error: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      email: '',
      formError: false,
      currentEmail: false
    }
  },
  computed: {
  },
  methods: {
    submitForm() {
      this.formError = null
      if (!this.email) {
        this.formError = 'Укажите email получателя'
        return
      }
      if (!this.currentEmail) {
        return
      }

      this.$emit('submit', this.email)
    }
  }
}
